/** f-edge paths; `cargoFetch` resolves them against `API_BASE`. */
export const cargoApi = {
  products: '/api/v1/cargo/products',
  estimate: '/api/v1/cargo/pricing/estimate',
  consignments: '/api/v1/cargo/consignments',
} as const

/** Route handlers of this app, the only URLs the browser calls. */
export const localApi = {
  estimate: '/api/cargo/pricing/estimate',
  consignments: '/api/cargo/consignments',
} as const
